import apiConfig from "../../apiConfig";

export const setDonationSidesExternalInitiativeStatus = async (at, donationSideId, statusId) => {
	const response = await apiConfig.post(
		"/API/CHARITY/LOOKUPS/Donations_Sides/Set_Donation_Side_External_Initiative",
		{
			Donation_Side_Id: donationSideId,
			IS_External_Initiative: statusId,
		},
		{
			headers: {
				Authorization: `Bearer ${at}`,
			},
		}
	);

	return response.data;
};
